export const pt = {
  clipboard: {
    successCopied: "Copiado para a área de transferência",
  },
  notification: {
    title: "Configurações de Notificação",
    emailNotifications: "Notificações por e‑mail",
    marketingEmails: "E‑mails de marketing"
  },
  safety: {
    title: "Verificação KYC",
    subtitle: "Conclua a verificação para acessar todos os recursos da plataforma.",
    bannerTitle: "Verificação via Reown",
    bannerText1: "Sua conta usa autenticação Reown.",
    bannerText2: "Para aumentar seu nível de verificação, vá para a seção \"Verificação\".",
    standardLevel: "Nível Padrão",
    standardDesc: "Confirmação de e‑mail e número de telefone.",
    enhancedLevel: "Nível Avançado",
    enhancedDesc: "Envio dos dados do passaporte.",
    professionalLevel: "Nível Profissional",
    professionalDesc: "Comprovante de endereço residencial.",
    completed: "Concluído",
    inProgress: "Em andamento",
    start: "Iniciar"
  },
  referral: {
    title: "Programa de Indicação",
    description: "Convide amigos e ganhe recompensas!",
    subtitle: "Seu link de indicação",
    yourReferrals: "Seus indicados",
    statsElements: ["Total de indicados", "Ativos", "Investimentos totais", "Seus ganhos"],
    yourLevel: {
      topTitle: "Seu nível",
      toNextLevel: "Próximo nível:",
      activeReferralsOr: "indicados ativos OU",
      toLvl: "até"
    },
    referrer: {
      title: "Tem um código de indicação? Insira aqui",
      enterCode: "Inserir código",
      check: "Verificar"
    },
    confirm: "Confirmar",
    changeRefCode: "Alterar código de indicação",
    newCode: "novo código",
    enterNewCode: "Insira seu novo código",
    minMaxChars: "Mínimo 6 caracteres, máximo 8"
  },
  referralNew: {
    code: {
      title: "Tem um código de indicação?",
      description: "Insira-o abaixo para se conectar\ncom quem o indicou.",
      input: "Código de indicação",
      button: "Verificar",
      title_CodeVerified: "Código verificado",
      description_CodeVerified: "Agora pode convidar outras pessoas e ganhar recompensas.",
      youInviter: "seu indicador"
    },
    details: {
      title: "Os seus detalhes de indicação",
      description: "Convide amigos para o Zenex e ganhe bônus.",
      sendThis: "Envie este link para o seu amigo",
      orShare: "Ou partilhe o seu código manual",
      members: "membros",
      paidOut: "pago em 2025",
      alreadyEarning: "já estão a ganhar\n connosco"
    },
    program: {
      button: "Saiba mais",
      cards: {
        title: "Níveis mensais",
        subtitle: "Programa de parceiros",
        description: "Ganhe com o volume de cartões dos seus indicados",
        how: "Como funciona",
        elements: [
          "Volume total de recargas de todos os indicados por mês civil",
          "Status recalculado no dia 1 de cada mês",
          "Comissão paga de acordo com o seu nível atual"
        ]
      },
      invest: {
        title: "Sistema cumulativo",
        subtitle: "Programa de indicação",
        description: "Ganhe com os investimentos dos seus amigos",
        how: "Como ganhar",
        elements: [
          "Convide um amigo para se juntar ao Zenex Invest",
          "Ele começa a investir nos Zenex Pools",
          "Você recebe recompensas dos ganhos dele"
        ]
      }
    }
  },
  innerReferral: {
    title: "Sistema de Indicação \n Zenex Invest",
    statistic: {
      pattern: " neste mês",
      status: {
        title: "Status atual",
        subtitle: "Seus bônus: ",
        description: "{depositBonus} do depósito e {incomeBonus} do lucro",
        labelLeft: "Até {level}",
        labelCenter: "{count, plural, one {# indicação} other {# indicações}} ou",
        labelRight: ""
      },
      referrals: {
        title: "Indicações ativas",
        description: "+{count} novas",
      },
      deposit: {
        title: "Valor total dos depósitos",
        description: "+{count}$"
      },
      income: {
        title: "Minha renda",
        description: "~{count}$",
        pattern: "/por mês",
      },
    },
    link: {
      title: "Aumente seu nível e ganhe mais",
      sendThis: "Envie este link para um amigo",
      orShare: "Ou compartilhe o código para inserção manual",
    },
    tabs: {
      levels: "Sistema de níveis",
      history: "Histórico de pagamentos",
      referrals: "Lista de indicações",
    },
    faq: {
      kicker: "FAQ",
      title: "Como funciona o sistema de indicação",
      questions: [
        "Para onde vão minhas recompensas e como posso sacá-las?",
        "O link de indicação é diferente para cada produto ou é único?",
        "Convidei um amigo que investiu no pool RevShare. Quando receberei minha recompensa?",
        "Como posso aumentar meu nível no programa de indicação?",
      ],
      answers: [
        "Suas recompensas são creditadas diretamente na carteira conectada à sua conta Zenex Hub, e você pode sacá-las para qualquer carteira externa.",
        "Existe um único link de indicação para todos os produtos Zenex. Compartilhando um único link, você recebe recompensas por qualquer produto utilizado pelo seu indicado.",
        "As recompensas começam a ser creditadas no mês seguinte. Você recebe uma parte do depósito (recompensa única) e uma parte do lucro (recompensas mensais recorrentes).",
        "Seu nível aumenta assim que o volume total de investimentos dos seus indicados atingir o valor necessário. O novo nível é aplicado no início do próximo mês.",
      ],
    },
    levels: {
      title: "Sistema de níveis e recompensas",
      description: "O nível é determinado pelo melhor indicador: número de indicações ativas ou valor total investido",
      status: {
        received: "Recebido",
        current: "Nível atual",
        blocked: "Bloqueado",
        more: "Faltam {count, plural, one {# indicação} other {# indicações}}",
      },
      level: {
        associate: "Associate",
        partner: "Partner",
        executive: "Executive",
        elite: "Elite",
        ambassador: "Ambassador",
      },
      rows: {
        referrals: "Indicações",
        total: "Total investido",
        incomeDeposit: "Ganhos do depósito",
        incomeStable: "Ganhos do Stable Pool",
        incomeGrowth: "Ganhos do Growth Pool",
      },
    },
    filters: {
      label: "Ordenar por",
      dateAscending: "Data: crescente",
      dateDescending: "Data: decrescente",
      incomeAscending: "Renda: crescente",
      incomeDescending: "Renda: decrescente",
    },
    pagination: "Página {current} de {total}",
    incomeHistory: {
      title: "Renda e histórico de pagamentos",
      column: {
        date: "Data",
        user: "Indicado",
        pool: "Pool",
        incomePercent: "Lucro",
        income: "Valor",
      },
    },
    referrals: {
      title: "Minhas indicações",
      column: {
        user: "Indicado",
        pool: "Pool",
        deposit: "Investimento",
        profit: "Lucro do indicado",
        earning: "Minha renda",
      },
    },
  },
  quest: {
    title: "Tarefas e conquistas",
    subtitle: "Conclua tarefas para ganhar bônus e recompensas!",
    subscribe: "Inscreva‑se no nosso Instagram!",
    follow: "Siga‑nos no X!",
    join: "Junte‑se ao nosso Telegram!",
    done: "Feito",
    complete: "Concluir"
  },
  account: {
    title: "Conta",
    fields: {
      name: "Nome",
      nickname: "Apelido",
      email: "Email",
      bio: "Bio"
    },
    verify: "Verificar",
    confirmChanges: "Confirmar alterações",
    updateSuccess: "Alterações salvas com sucesso",
    updateError: "Falha ao salvar alterações",
    linksTitle: "Vincule suas contas para recursos adicionais",
    connectX: "Conectar X",
    connectTelegram: "Conectar Telegram",
    connectInstagram: "Conectar Instagram",
    logout: "Sair",
    emailDialog: {
      title: "Verifique seu e‑mail",
      description1: "Enviamos um código de 6 dígitos para {email}",
      description2: "Digite abaixo para concluir seu cadastro e acessar todos os recursos do Zenex Hub.",
      confirmBtn: "Confirmar e‑mail",
      cantFind: "Não encontrou o e‑mail? Verifique sua pasta de Spam",
      resend: "ou solicite um novo",
      sentPrefix: "Enviamos um código de 6 dígitos para"
    },
    cancel: "Cancelar",
    saveChanges: "Salvar alterações",
    selectNewAvatar: "Selecionar novo avatar",
    unsavedChanges: {
      title: "Alterações não salvas",
      subtitle: "Você tem alterações não salvas. Descartá-las e sair?"
    }
  },
  sell: {
    to: "Sacar para",
    select: "Selecionar token",
    button: "Sacar",
    loading: "Sacando…"
  },
  errors: {
    insufficientFunds: "Fundos insuficientes",
    maxLimit: "O limite máximo é {value}$",
    serviceUnavailable: "Serviço indisponível, por favor tente novamente mais tarde",
  },
  card: {
    title: {
      white: "— A nova era dos pagamentos com cartão começa aqui!",
      green: "pela Zenex",
      yellow: "NS.Cards"
    },
    description:
      "Zero taxas de transação, restrições MCC, limites de gastos até US$ 100.000 — tudo isso e muito mais com o cartão Zenex.",
    button: "Solicitar seu cartão",
    columns: {
      left: {
        title: {
          white: "NS.CARDS para\n",
          green: "Mediabuyers"
        },
        items: [
          "Recarregue com cripto ou fiat a partir de 2,5%",
          "Sem KYC",
          "0% de taxas de transação em MCCs relacionados a ADS"
        ],
        cta: "Obter o cartão"
      },
      right: {
        title: {
          white: "NS.CARDS",
          yellow: "Cartão Wild sem limites"
        },
        items: [
          "Recarregue com cripto ou fiat a partir de 2,5%",
          "Sem limites de MCC",
          "Apple Pay/Google Pay + opções físicas",
          "$100k/mês para suas transações"
        ],
        cta: "Obter o cartão"
      }
    }
  },
  investHome: {
    title: "Pools de RevShare",
    description:
      "O primeiro RWA de iGaming — Financie tráfego de cassino e ganhe % do GGR da plataforma ao entrar nos pools de RevShare ZNX para ganhos conservadores ou de alto rendimento.",
    button: "Zenex Invest"
  },
  invest: {
    title: "Pools de Tráfego",
    description:
      "Participação no NGR do tráfego do White Rabbit Casino (Cazaquistão) - whiterabbit.casino \n" +
      "Compramos tráfego de alta qualidade, convertemos em depósitos e compartilhamos o lucro.",
    button: "Acompanhar atualizações",
    dashboardTitle: "Painel de investimento",
    secondPageDescription1: "Ganhe GGR de plataformas de cassino.",
    secondPageDescription2: "Compramos tráfego de alta qualidade, convertemos em depósitos e compartilhamos o lucro.",
    dashboardDescription: "Gerencie seus investimentos e acompanhe o desempenho de todos os pools.",
    investFirstRowElements: [
      "anos de experiência", "Reg2Dep", "ROI mensal", "de GGR = NGR"
    ],
    poolsTitle: "Pools disponíveis",
    pools: ["membros", "tipos de pools", "meses", "ZNX\nlimite total"],
    poolsOffers: {
      titlesStable: ["Garantia de retorno de 100% do capital", "34-42,5% do GGR", "Pagamentos em USDC"],
      titlesGrowth: ["Máximo upside do ZNX", "8,5-12,75% do GGR", "Pagamentos em USDC"],
      whyHint: {
        safeTitle: "Por que uma % do GGR mais alta?",
        safeText: "Adquirimos seus ZNX pelo valor atual em USD. A % é mais alta porque\ncompramos seus tokens e compartilhamos o máximo de lucros. O retorno garantido\ndo seu investimento em equivalente USD mantém seus fundos\nseguros.",
        growthTitle: "Por que uma % do GGR mais baixa?",
        growthText: "Por 12 meses, fazemos a gestão dos seus tokens ZNX, garantindo que você receba todo o seu investimento de volta ao final do período.\nA % é mais baixa porque você mantém a propriedade e o potencial de valorização do token"
      },
      amountStaked: "Quantidade em stake"
    },
    poolsOffersRow: {
      payoutsStable: ["34% do GGR", "38,25% do GGR", "42,5% do GGR"],
      payoutsGrowth: ["8,5% do GGR", "10,625% do GGR", "12,75% do GGR"]
    },
    poolButton: "Entrar no pool",
    nrgComeFrom: {
      title: "De onde vem o NGR para os pagamentos?",
      nrgElements: {
        titles: ["GGR dos jogadores", "Menos 15%", "= NGR", "Aos participantes do pool"],
        subTitles: ["Gross Gaming Revenue", "Despesas administrativas\n do cassino", "Net Gaming Revenue", "De acordo com o nível\n e o tipo de pool"]
      },
      description: "Exemplo: GGR $100k → NGR $85k → Os participantes recebem entre $8,5k e $42,5k, dependendo do pool e do nível."
    },
    howItWorks: {
      title: "Como funciona?",
      elements: {
        titles: ["Agrupando tokens ZNX", "Aquisição de tráfego", "Geração de lucro", "Pagamentos mensais", "Retorno do investimento inicial"],
        descriptions: [
          "Os participantes depositam tokens ZNX\n até o limite de 230k/mês",
          "Compramos tráfego de alta qualidade no modelo CPA\n para o White Rabbit Casino",
          "O cassino gera GGR\n= ‘perdas’ dos jogadores – ‘ganhos’ dos jogadores",
          "Participantes recebem % do GGR\n em USDC por nível e tipo de pool todos os meses",
          "Os tokens colocados no pool\n serão totalmente devolvidos após 12 meses"
        ]
      }
    },
    faq: {
      title: "Perguntas frequentes",
      questions: [
        "O que são os Zenex RevShare Pools?",
        "Como os pagamentos são feitos?",
        "Como meu pagamento mensal é calculado?",
        "Posso sair do pool antes do prazo?",
        "O que acontece se o pool não atingir o valor alvo?",
        "Quando meus ZNX serão devolvidos?",
      ],
      answers: [
        "Os Zenex RevShare Pools são uma tokenização RWA de um negócio real de cassino. Você adquire tokens ZNX, os coloca em pools de aquisição de tráfego para <span>whiterabbit.casino</span> e recebe uma porcentagem fixa do Gross Gaming Revenue (GGR) todos os meses por 12 meses.",
        "Os pagamentos são realizados mensalmente em USDC no dia 15 de cada mês durante 12 meses. Os fundos chegam ao seu saldo no ZNX Hub e podem ser sacados imediatamente ou reinvestidos.",
        "Seu pagamento depende de dois fatores: sua participação no pool e o desempenho mensal do GGR do cassino.",
        "Não, a saída antecipada não é possível. Os fundos ficam bloqueados em um smart contract por 12 meses. Isso nos permite planejar campanhas de marketing e garantir retornos estáveis.",
        "O pool será lançado de qualquer forma. As proporções de distribuição de lucros serão determinadas após as compras mensais de tráfego.",
        "100% dos tokens ZNX que você colocou no pool serão devolvidos automaticamente após 12 meses.",
      ]
    },
    betshops: {
      title: "Betshops"
    },
    questions: {
      title: "Ainda tem dúvidas?",
      subtitle: "Entre em contato com nossa equipe agora para encontrar o melhor pool para seus objetivos!",
      button: "Fale conosco"
    },
    moreInfo: {
      title: "Mais informações sobre os pools Zenex RevShare",
      telegram: "Nosso Telegram",
      instagram: "Nosso Instagram",
      linkedin: "Nosso LinkedIn"
    },
    payoutVariations: {
      title: "Como os pagamentos podem variar",
      inputLabel: "Insira o valor do investimento",
      weakLabel: "Cenário fraco",
      strongLabel: "Cenário forte",
      months: [
        "Hoje",
        "Jan 2025",
        "Abr 2025",
        "Jul 2025",
        "Out 2025",
        "Jan 2026",
        "Abr 2026",
        "Jul 2026",
        "Out 2026",
        "Dez 2026"
      ],
      weakScenarioLabel: "Retorno total no cenário fraco (sem crescimento de preço)",
      strongScenarioLabel: "Retorno total no cenário forte (crescimento de preço de 150%)",
      disclaimer: "Os cálculos são baseados no desempenho histórico e não constituem previsões."
    },
    header: {
      smallTitle: "Pools Zenex RevShare",
      mainHeading: "Acesse a receita de cassinos sem custos operacionais nem riscos",
      description: "Compramos tráfego de alta qualidade para cassinos, convertimos em depósitos e compartilhamos os lucros",
      ctaStartEarning: "Começar a ganhar",
      ctaViewStatistics: "Ver estatísticas",
      stats: {
        item1: {
          value: "60 meses",
          description: {
            prefix: "Lucratividade comprovada do",
            link: "White Rabbit Casino"
          }
        },
        item2: {
          value: "40%+",
          description: "Conversão reg→dep líder no setor"
        },
        item3: {
          value: "Transparente",
          description: "Relatórios de performance e dados mensais"
        },
        item4: {
          value: "Duas fontes de renda",
          description: "Pagamentos mensais em USDC e devolução total do seu ZNX com potencial de valorização"
        }
      }
    },
    enterToPoolDialog: {
      title: "Quantidade total de ZNX",
      availableBalance: "Saldo disponível",
      stakedInPool: "Em stake neste pool",
      buttonTopUp: "Adicionar saldo",
      buttonEnterPool: "Entrar no pool",
      choosePlan: "Escolha seu plano",
      inputLabel: "Digite a quantidade de ZNX",
      inputMessages: {
        exceedsBalance: "Excede o saldo",
        increase: {
          toIncrease: "Para aumentar seu",
          addAdditional: "adicione mais",
          stable: {
            toBasic: "GGR para 34%",
            toAdvanced: "GGR para 38,25%",
            toPremium: "GGR para 42,5%"
          },
          growth: {
            toBasic: "GGR para 8,5%",
            toAdvanced: "GGR para 10,625%",
            toPremium: "GGR para 12,75%"
          }
        }
      }
    },
    myActivePools: {
      title: "Meus Pools Ativos",
      myActivePoolElements: ["Em stake", "Plano\n atual", "GGR"],
      myActivePoolElementsV2: ["Tamanho do pool", "Em stake", "Plano atual", "GGR", "Total ganho"],
      growUp: "Atualize seu plano para aumentar os ganhos!",
      missing: "Faltam",
      buttonStats: "Ver estatísticas",
      buttonAddZNX: "Adicionar ZNX",
      buttonClaim: "Resgatar",
      months: {
        january: "Janeiro",
        february: "Fevereiro",
        march: "Março",
        april: "Abril",
        may: "Maio",
        june: "Junho",
        july: "Julho",
        august: "Agosto",
        september: "Setembro",
        october: "Outubro",
        november: "Novembro",
        december: "Dezembro"
      },
      status: {
        active: "Ativo até {date}",
        prefunding: "Pré-financiamento",
        closed: "Encerrado",
      },
      upgrade: {
        label: "Atualize seu plano para",
        boost: "Aumente os ganhos para {percent}% do GGR ({ggr})",
        missing: "Falta: ",
      },
    },
    stats: {
      title: "Painel de Analytics White Rabbit",
      description: "Analytics Operacional",
      claimButton: "Claim",
      chartPerios: ["1d", "1w", "1m"],
      chartLine: "Dinâmica do GGR",
      barLine: "Dinâmica de Jogadores Ativos",
      addZnx: "Adicionar ZNX",
      spent: "Gasto",
      ftdLabel: "FTD\n(Primeiros depositantes)",
      cpaLabel: "CPA\n(Custo por FTD)",
      averageDeposit: "Depósito médio",
      ggrThisMonth: "GGR deste mês",
      totalGgr: "GGR total",
      day: "Dia {day}",
      activity: {
        title: "Status de atividade do pool",
        status: {
          active: "Ativo até {date}",
          prefunding: "Pré-financiamento",
          closed: "Encerrado",
          traffic: "Aquisição de tráfego"
        },
      },
      prefunding: {
        goal: "Meta de captação",
        raised: "Arrecadado",
        investors: "Investidores",
        launch: "Lançamento em"
      },
      stake: {
        label: "Minha participação",
        elements: ["Em stake", "Plano atual", "GGR", "Próximo pagamento", "Total ganho"],
      },
      upgrade: {
        label: "Atualize seu plano para",
        boost: "Aumente os ganhos para {percent}% do GGR ({ggr})",
        missing: "Falta: ",
      },
      placeholderPool: {
        title: "As estatísticas aparecerão após o lançamento do pool",
        description: "Invista agora para ter acesso antecipado aos dados de desempenho!",
        action: "Entrar no pool",
      },
      myPayouts: {
        title: "Meus pagamentos",
        action: "Resgatar",
        pool: "Pagamento de {pool} de {month}",
        stable: "Stable Pool",
        growth: "Growth Pool",
        eta: {
          days: "{count, plural, one {# dia} other {# dias}}",
          hours: "{count, plural, one {# hora} other {# horas}}",
        },
      },
      months: {
        january: "Janeiro",
        february: "Fevereiro",
        march: "Março",
        april: "Abril",
        may: "Maio",
        june: "Junho",
        july: "Julho",
        august: "Agosto",
        september: "Setembro",
        october: "Outubro",
        november: "Novembro",
        december: "Dezembro"
      },
      yourPayouts: "Seus"
    },
    transparency: {
      title: "Transparência",
      lastUpdated: "Última atualização:",
      dataSource: "Fonte de dados:",
      crossGamingRevenue: "Gross Gaming Revenue",
      adminFee: "Taxa administrativa (15%)",
      netGamingRevenue: "Net Gaming Revenue",
      totalDeposits: "Depósitos totais",
      playersCount: "Número de jogadores"
    },
    overview: {
      title: "Visão Geral do Investimento Pessoal",
      totalInvested: "Total investido",
      totalEarned: "Total ganho",
      nextPayout: "Próximo pagamento",
      poolShare: "Sua participação no pool:",
      roi: "ROI:",
      paymentDate: "Data do pagamento:",
      poolMetrics: "Métricas do Pool",
      poolSize: "Tamanho do pool",
      investors: "Investidores",
      staked: "Em stake",
      players: "Jogadores"
    },
    totalStaked: {
      title: "Total em Stake nos Pools",
      button: "Investir nos Pools",
      stable: "stable pool",
      growth: "growth pool",
      totalFormat: "{total}/{max} ZNX"
    },
    whiteRabbitPromo: {
      title: "Estatísticas do Pool White Rabbit",
      subtitle: "Veja os números, calcule seus ganhos, junte‑se agora",
      button: "Abrir Estatísticas"
    },
    poolMetrics: {
      title: "Métricas do Pool",
      metricsElements: ["Tamanho do pool", "Investidores", "Em stake", "Jogadores"]
    },
    growthDetails: {
      title: "Zenex Growth Pool",
      progress: {
        label: "Progresso do pool"
      },
      metrics: {
        ggrShareLabel: "Parcela do GGR do cassino",
        lockPeriodLabel: "Período de bloqueio",
        lockPeriodValue: "12 meses",
        payoutsUSDCLabel: "Pagamentos em USDC",
        payoutsFrequencyValueMonthly: "Mensal",
        returnedAfterLabel: "Devolvido após 12 meses",
        returnedAfterValue: "100% ZNX"
      },
      tooltips: {
        tierShare: "Sua participação no cassino depende do nível (Tier)",
        payoutsDepend: "Os pagamentos dependem do GGR mensal do cassino",
        noEarlyWithdrawal: "Sem saque antecipado",
        znxGrowth: "Se o ZNX subir, seu retorno final também cresce"
      },
      tier: {
        depositLabel: "Depósito:",
        note: "O nível é determinado automaticamente pelo valor do depósito"
      },
      button: {
        closed: "Arrecadação encerrada"
      }
    },
    joinPool: "Entrar no pool",
    poolsPromoTitle: "As estatísticas aparecerão após o lançamento do pool",
    poolsPromoSubtitle: "Invista agora para ter acesso antecipado aos dados de desempenho!"
  },
  buy: {
    currency: "Moeda",
    network: "Rede",
    sum: "Quantia",
    min: "Mínimo",
    max: "Máximo",
    loading: "Carregando…",
    buy: "Comprar",
    approve: "Transferir {amount} {currency} para o endereço:"
  },
  claim: {
    have: "Você tem",
    available: "tokens disponíveis",
    description:
      "Clique no botão \"Claim\" para adicioná‑los ao saldo da sua conta.",
    button: "Claim",
    check: "Verificar",
    total: "Sua pontuação total",
    tooltip: "Campo opcional",
    notice: {
      white: "Digite o código de bônus para receber",
      green: "x2 tokens ZNX."
    },
    errors: {
      invalidCode: "Código inválido",
      codeExpired: "O código expirou.",
      codeRequired: "O código é obrigatório."
    },
    optional: "Campo opcional"
  },
  page: {
    title: {
      green: "Bem‑vindo ao",
      yellow: "Zenex Hub!"
    },
    descriptions1:
      "Obrigado por acreditar em nós e querer crescer conosco!",
    descriptions2:
      "Estamos na fase final de testes e em breve revelaremos toda a funcionalidade.",
    descriptions3: "Jogue agora para reivindicar seus",
    descriptions4: "tokens grátis",
    descriptions5: "— não perca!",
    buttons: {
      play: "Jogar Caça ao Tesouro",
      get: "Obter ZNX"
    },
    notice: "Esta oferta está disponível por tempo limitado.",
    back: "Voltar",
    tabs: {
      account: "Conta",
      safety: "Segurança",
      notifications: "Notificações",
      referrals: "Indicações",
      quests: "Tarefas"
    }
  },
  balance: {
    title: "Suas coleções de NFT"
  },
  header: {
    title: {
      profile: "Configurações do Perfil",
      reshare:"Investimento"
    },
    welcome: "Bem‑vindo {username}!",
    welcome_empty: "Bem‑vindo!",
    button: {
      logout: "Sair"
    },
    labels: {
      address: "Endereço:",
      caipAddress: "Endereço CAIP:",
      status: "Status:"
    },
    dropdown: {
      supportChat: "Chat de suporte",
      documents: "Documentos",
      legalDocuments: "Documentos legais",
      termsOfUse: "Termos de uso",
      privacyPolicy: "Política de privacidade",
      cookiesPolicy: "Política de cookies",
      buyZNXwithCrypto: "ZNX com criptomoeda",
      buyZNXonDEX: "ZNX na DEX",
      buyZNXwithCard: "ZNX com cartão"
    }

  },
  login: {
    title: {
      green: "Bem‑vindo ao",
      white: "Zenex Hub!"
    },
    button: "Conectar"
  },
  plans: {
    title: "Programas de Acesso ao Investimento Zenex",
    welcome: "Bem‑vindo {username}!",
    welcome_empty: "Bem‑vindo!",
    cards: {
      silver: {
        title: "Nível Prata",
        subtitle: "Investidor Inicial",
        items: [
          "1.000 vagas",
          "ZNX Play: Staking ×1,5 (6 meses)",
          "ZNX Arena: 5 cartas padrão + 1 dourada",
          "ZNX Invest: Acesso exclusivo a pools",
          "Bônus: 850 ZNX"
        ]
      },
      gold: {
        title: "Nível Ouro",
        subtitle: "Parceiro Estratégico",
        items: [
          "200 vagas",
          "ZNX Play: Staking ×2 (12 meses)",
          "ZNX Arena: 8 cartas padrão + 2 douradas",
          "ZNX Invest: +10% de rendimento do pool",
          "Bônus: 4.200 ZNX"
        ]
      },
      platinum: {
        title: "Nível Platina",
        subtitle: "Investidor VIP",
        items: [
          "50 vagas",
          "ZNX Play: Staking ×3 (12 meses)",
          "ZNX Arena: 10 cartas padrão + 3 douradas",
          "ZNX Invest: +20% de rendimento do pool",
          "Chat privado de insiders",
          "Bônus: 12.500 ZNX"
        ]
      },
      diamond: {
        title: "Nível Diamante",
        subtitle: "Parceiro Fundador",
        items: [
          "20 vagas",
          "ZNX Play: Staking ×4 (12 meses)",
          "ZNX Arena: 10 cartas padrão + 5 douradas",
          "ZNX Invest: +30% de rendimento + alocações garantidas",
          "Chat privado + influência na plataforma",
          "Menção no Hall da Fama",
          "Bônus: 12.500 ZNX"
        ]
      }
    },
    button: "Comprar",
    available: "Vagas Disponíveis",
    benefits: "Benefícios"
  },
  opportunities: {
    cards: {
      play: {
        title: "ZNX Play",
        description: "Segure ZNX, ganhe recompensas — sem esforço."
      },
      invest: {
        title: "ZNX Invest",
        description:
          "Ganhe com o primeiro RWA de iGaming com apenas 50 ZNX"
      },
      cases: {
        title: "Cases e Baús",
        description: "Abra cases para recompensas aleatórias, reforços ou vantagens."
      },
      arena: {
        title: "ZNX Arena",
        description:
          "Lucre com promotores competindo por clientes em um reality show de negócios."
      }
    },
    button: "Em breve",
    buttonOpen: "Abrir"
  },
  meta: {
    title: "Português"
  },
  cards: {
    transactions: {
      title: 'Últimas transações',
      column: {
        card: "Cartão",
        date: "Data",
        details: "Detalhes",
        status: "Status",
        amount: "Valor",
        fee: "Taxa"
      },
      status: {
        RESERVED: "Reservado",
        UNRESERVED: "Liberado",
        TRANSFERRED: "Transferido",
        REFUNDED: "Reembolsado",
        REFUNDED_PARTIAL: "Reembolso parcial",
        FAILED: "Falhou",
        LOADED: "Carregado",
        UNLOADED: "Descarregado",
        COMPLETED: "Concluído"
      }
    },
    myCards: {
      title: "Meus cartões",
      goToSite: "Ir para NS.Cards",
      balance: 'Saldo',
      buyNewCards: "Comprar novo cartão",
      cardRedirect: "Você será redirecionado para um serviço externo para concluir sua compra",
      topUpZnx: "Recarregar com ZNX",
      confirmTopUp: "Confirmar recarga",
      topUpAmount: 'Valor da recarga',
      viewAllCards: 'Ver todos os cartões',
      hideCards: 'Ocultar cartões',
      loading: 'Carregando',
      loadingAddress: 'Carregando endereço de depósito...',
    }
  },
  wallet: {
    title: {
      main: "Carteira",
      mainNew: "Carteira não custodial",
      cards: "Zenex Cards",
      balance: "Ativos Totais",
      transaction: "Histórico de Transações",
      calendar: "Calendário de Pagamentos",
      payments: "Próximos Pagamentos"
    },
    availableBalance: "Saldo disponível",
    chooseAssets: "Escolha um ativo",
    walletNetworkDeposit: "Rede de depósito",
    walletNetworkWithdraw: "Rede de saque",
    address: "Endereço",
    destinationAddress: "Endereço de destino",
    enterAddress: "Digite o endereço",
    pasteWalletAddress: "Cole o endereço da carteira",
    enterAmount: "Insira o valor",
    withdrawAmount: "Quantia para sacar",
    minimumWithdrawAmount: "Valor mínimo para saque: {value}",
    transactionDetails: "Detalhes da transação",
    transactionFee: "Taxa de transação",
    insufficientFundsForFee: "Fundos insuficientes para cobrir a taxa da transação.",
    missing: "Falta: {value}",
    addSol: "Adicionar SOL",
    paste: "Colar",
    max: "Máx",
    doubleCheckWithdraw: "Por favor, verifique duas vezes o endereço de saque!",
    doubleCheckDeposit: "Por favor, verifique duas vezes o endereço de depósito!",
    sendingFundsToWrong: "Enviar fundos para o endereço errado pode resultar na perda irreversível\n da sua criptomoeda.",
    theProcedureUpTo48Hours: "O procedimento pode levar de 1 a 2 minutos!",
    theProcedureUpTo30min: "O procedimento pode levar até 30 minutos",
    exRate: "Taxa de câmbio",
    swap: "Confirmar",
    sell: "Vender",
    receive: "Receber",
    send: "Enviar",
    mainTitle: "Troca",
    amount: "Quantia",
    toSwap: "Trocar",
    searchTokens: "Pesquisar qualquer token",
    selectCurrency: "Selecionar moeda",
    selectCurrencyOrNetwork: "Selecionar moeda ou rede",
    selectToken: "Selecionar token",
    selectNetwork: "Selecionar rede",
    continueInWallet: "Continuar na carteira",
    swapReview: "Revise os detalhes da transação\n antes da confirmação!",
    depositAddress: "Endereço de depósito",
    walletDepositLoading: "Aguarde, seu endereço de depósito está sendo gerado...",
    walletSwapDepositLoading: "Aguarde enquanto sua operação de troca está sendo iniciada...",
    swapPage: {
      youSend: "Você envia",
      youReceive: "Você recebe",
      swapMinDeposit: "Depósito mínimo",
      fee: "Taxa",
      feeWithdraw: "Taxa de saque",
      finish: "Concluir",
      swapSuccess: "Swap concluído com sucesso",
      swapError: "Falha no swap. Tente novamente."
    },
    balanceButtons: {
      deposit: "Depositar",
      withdraw: "Sacar",
      exchange: "Trocar",
      buyZNX: "Comprar ZNX"
    },
    transactionHistory: {
      type: "Tipo",
      total: "Total",
      info: "Info",
      date: "Data",
      status: "Status"
    }
  },
  paymentProcess: {
    awaitingPayment: "Aguardando pagamento",
    confirmed: "Confirmado",
    swapped: "Trocado",
    swapping: "Trocando",
    sending: "Enviando ZNX",
    sendingToken: "Enviando {token}",
    usualTime: "Isso geralmente leva de 5 a 30 minutos."
  },
  transactionStatus: {
    complete: "Transação concluída!",
    failed: "Transação falhou",
    withdrawFailed: "Saque falhou",
    successSend: "{token} foi enviado com sucesso para sua carteira.",
    errorOccurred: "Ocorreu um erro ao processar a transação.",
    viewOnExplorer: "Ver no Block Explorer",
    contactSupport: "Contactar suporte",
    backToWallet: "Voltar à carteira",
    withdrawComplete: "Saque concluído!",
    withdrawAmountLabel: "Valor do saque",
    destinationAddressLabel: "Endereço de destino",
    estimatedProcessingTimeLabel: "Tempo estimado de processamento",
    transactionFeeLabel: "Taxa da transação",
    continueInWallet: "Continuar na carteira",
    checkOnSolscan: "Ver no Solscan",
    withdrawEtaValue: "{value} minutos",
    withdrawEtaDefault: "1-2 minutos",
    swapComplete: "Troca concluída!",
    swapFailed: "Troca falhou",
    youSendLabel: "Você envia",
    exchangeRateLabel: "Taxa de câmbio",
    youGetLabel: "Você recebe"
  },
  play: {
    banner: {
      title: "Staking & Loteria",
      description: "Faça stake de seus tokens $ZNX para ganhar recompensas. Quanto mais tempo em stake, maiores as chances de ganhar!"
    },
    statsSmall: {
      previousJackpot: "Jackpot Anterior",
      upcomingPayment: "Próximo Pagamento",
      activeParticipants: "Participantes Ativos"
    },
    ctaStake: "Fazer stake e ganhar",
    chipActive: "Ativo",
    stats: {
      totalValueStaked: "Valor Total em Stake",
      activeStakers: "Stakers Ativos",
      currentPrizePool: "Prêmio Atual"
    },
    nextDraws: {
      title: "Próximos Sorteios",
      description: "Contagem regressiva para o próximo sorteio de prêmios. Não perca sua chance!"
    },
    jackpots: {
      weekly: "JACKPOT SEMANAL",
      monthly: "JACKPOT MENSAL",
      annual: "JACKPOT ANUAL"
    },
    time: {
      days: "Dias",
      hours: "Horas",
      minutes: "Minutos"
    },
    prizeSub: "no prêmio",
    stakeDialog: {
      header: "Iniciar Staking",
      description: "Escolha quantia e duração para máximo potencial de lucro",
      labelAmount: "Quantia para Stake (ZNX)",
      placeholderAmount: "Digite a quantia",
      max: "MÁX",
      infoMessage: "Aumente o stake para 500 ZNX para dobrar seu lucro potencial!",
      plan: {
        multiplier: "Multiplicador",
        labelApy: "APY Fixo"
      },
      stats: {
        weeklyDistribution: "Distribuição Semanal",
        monthlyDistribution: "Distribuição Mensal",
        totalPotentialProfit: "Lucro Potencial Total"
      },
      createStake: "Criar Stake"
    },
    summaryRow: {
      stakeAmount: "Quantia em Stake",
      duration: "Duração",
      fixedApy: "APY Fixo",
      guaranteedProfit: "Lucro Garantido",
      additionalProfitChance: "Chance de Lucro Adicional"
    }
  },
  connectDialog: {
    text: "Conecte sua carteira para ver todos os produtos disponíveis!",
    button: "Conectar carteira"
  },
  profileCard: {
    hiUser: "Olá, usuário",
    copyFullAddress: "Copiar endereço completo",
    profileSettings: "Configurações do perfil"
  },
  welcomeDashboard: {
    subTitle: "Engaje. Ganhe. Potencialize.",
    description: "O primeiro ecossistema iGaming‑Fintech com Casino RWA e soluções revolucionárias!",
    button: "Conectar carteira",
    revsharePools: {
      titleAccent: "Revshare",
      titleRest: "pools",
      description1: "O primeiro RWA de iGaming — Financie tráfego de cassino em CPA e ganhe % da receita da plataforma (GGR)",
      description2: "entrando nos pools RevShare da ZNX para ganhos conservadores ou de alto rendimento.",
      cta: "Começar a ganhar"
    },
    dashboardElements: {
      invest: {
        text: "Ganhe todos os meses com os produtos Casino RWA líderes do setor",
        button: "Ganhe ZNX e USDC"
      },
      play: {
        text: "Segure ZNX, ganhe renda passiva,\ne multiplique‑a em nossos mini‑jogos.",
        button: ""
      },
      arena: {
        text: "Lucre com promotores competindo por clientes no primeiro reality de negócios de cassino.",
        button: ""
      }
    },
    dashboardReferral: {
      boost: "Aumente seus ganhos com",
      programName: "Programa de Indicação"
    },
    dashboardConnect: {
      subTitle: "Envolva-se. Ganhe. Empodere-se.",
      text: "O primeiro ecossistema iGaming-Fintech\ncom Casino RWA e soluções revolucionárias!"
    },
    dashboardPartners: {
      title1: "Rede global.",
      title2: "Visão partilhada.",
      subTitle: "Integrado com os principais parceiros de iGaming e fintech, aproveitamos as tecnologias de blockchain e contratos inteligentes\n para desenvolver soluções de próxima geração."
    },
    dashboardPhotos: {
      title: "Momentos",
      subtitle: "Pessoas. Energia. Inovação.",
      followUs: "Siga-nos para mais momentos",
      texts: {
        We_brought: "Trouxemos o espírito Web3 para o MAC Erevan",
        Innovation_networking: "Inovação, networking e ideias ousadas — é o CPA Life Fest com a Zenex",
        Zenex_at: "Zenex na BroConf — energia pura",
        Connecting_minds: "Conectando mentes no TOKEN2049",
        Game_on: "O jogo continua no SBC Summit",
        From_insights: "De insights à ação — no CPA Life Fest",
        TOKEN2049_vibes: "Vibes TOKEN2049: conversas reais, crescimento, energia",
        Behind_every: "Por trás de cada evento há uma história — de ideias ousadas, parcerias e experiências inesquecíveis que impulsionam a comunidade Zenex para a frente.",
        Bright_ideas: "Ideias brilhantes, SiGMA"
      }
    }
  }
};
